import * as React from 'react';
import PropTypes from 'prop-types';
import { uid } from 'react-uid';
import { Stack } from '@mui/material';
import MobileAccordion from './MobileAccordion';
import DistributionDataAccordion from './DistributionAccordion';

export default function MobileDistributionsTable({
  distributionData, showUnPaidDistributions, fundCode, distributionLabel,
  fundTotalDistributions, year,
}) {
  const allDistributionsView = (!showUnPaidDistributions);

  if (allDistributionsView) {
    const [expanded, setExpanded] = React.useState('');
    const handleChange = (panel) => {
      if (expanded === panel) {
        setExpanded('');
      } else {
        setExpanded(panel);
      }
    };
    const accordions = distributionData.map((row) => {
      const key = uid(row);
      return (
        <MobileAccordion
          panelName={key}
          row={row}
          handleChange={handleChange}
          expanded={expanded}
          key={key}
        />
      );
    });

    return (
      <Stack>
        {year && (
        <div
          style={{
            width: '100%',
            display: 'inline-block',
            textAlign: 'center',
            backgroundColor: '#e0e0e0',
            marginBottom: '8px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 600,
            height: '23px',
            lineHeight: '23px',
          }}
        >
          {year}
        </div>
        )}
        { accordions }
      </Stack>
    );
  }
  return (
    <Stack>
      <DistributionDataAccordion
        distributionData={distributionData}
        fundCode={fundCode}
        distributionLabel={distributionLabel}
        fundTotalDistributions={fundTotalDistributions}
      />

    </Stack>
  );
}

MobileDistributionsTable.propTypes = {
  distributionData: PropTypes.arrayOf(PropTypes.object).isRequired,
  fundCode: PropTypes.string,
  distributionLabel: PropTypes.string,
  showUnPaidDistributions: PropTypes.bool.isRequired,
  fundTotalDistributions: PropTypes.string,
  year: PropTypes.number,
};

MobileDistributionsTable.defaultProps = {
  fundCode: '',
  distributionLabel: '',
  fundTotalDistributions: '',
  year: undefined,
};
